import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_de.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.de.js'
import 'moment/locale/de.js'
import './translations.tc.de.js'

$.fn.datepicker.defaults.language = 'de'

I18n.defaultLocale = 'de'
I18n.locale = 'de'

export default App
